import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { PhaseToolbarModel } from './../../models/phases-toolbar.model';

@Component({
  selector: 'kv-phases-toolbar',
  templateUrl: 'phases-toolbar.component.html',
  styleUrls: ['phases-toolbar.component.css']
})
export class PhasesToolbarComponent implements OnInit {

  @Input() phases: Array<PhaseToolbarModel> = [];

  @Output() onClickPhase: EventEmitter<PhaseToolbarModel> = new EventEmitter<PhaseToolbarModel>();

  singlePhaseWidth: number = 100;

  constructor () { }

  ngOnInit(): void {
    this.singlePhaseWidth = (100 / this.phases.length);
  }
  onClick(phase: PhaseToolbarModel){
    this.onClickPhase.emit(phase);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/phases-toolbar/phases-toolbar.component.ts